import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";

const EditQuestions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { id } = useParams();

  const [formData, setFormData] = useState({
    question: "",
    options: ["", "", "", ""],
    correctAnswer: 0,
    difficulty: "Easy",
    marks: 1,
  });

  // ✅ SET DATA FROM LOCATION STATE
  useEffect(() => {
    if (!state) {
      toast.error("No question data found");
      navigate("/exam/questions");
      return;
    }

    setFormData({
      question: state.question,
      options: state.options,
      correctAnswer: state.correctAnswer,
      difficulty: state.difficulty,
      marks: state.marks,
    });
  }, [state, navigate]);

  // 🔹 Handle input change
  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "marks" || name === "correctAnswer" ? Number(value) : value,
    }));
  };

  // 🔹 Handle option change
  const handleOptionChange = (index: number, value: string) => {
    const updatedOptions = [...formData.options];
    updatedOptions[index] = value;
    setFormData({ ...formData, options: updatedOptions });
  };

  // 🔹 Update question
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      questionId: state._id,
      ...formData,
    };
    AdminService.updateQuestions(payload).then((res: any) => {
      if (res.status === "Fail") {
        toast.error(res.message);
      } else {
        toast.success(res.message);
        navigate("/exam/questions");
      }
    });
  };

  return (
    <div>
      <div className="row">
        <Header />
      </div>

      <div className="row">
        <div className="col-md-2 px-0">
          <Sidebar />
        </div>

        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 className="mb-3">Edit Question</h4>

          <form onSubmit={handleSubmit}>
            <div className="card shadow">
              <div className="card-body">
                {/* Question */}
                <div className="mb-3">
                  <label className="form-label">Question</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Options */}
                {formData.options.map((opt, index) => (
                  <div className="mb-2" key={index}>
                    <label className="form-label">Option {index + 1}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={opt}
                      onChange={(e) =>
                        handleOptionChange(index, e.target.value)
                      }
                      required
                    />
                  </div>
                ))}

                {/* Correct Answer */}
                <div className="mb-3">
                  <label className="form-label">Correct Answer</label>
                  <select
                    className="form-select"
                    name="correctAnswer"
                    value={formData.correctAnswer}
                    onChange={handleChange}
                  >
                    {formData.options.map((_, index) => (
                      <option key={index} value={index}>
                        Option {index + 1}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Difficulty & Marks */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Difficulty</label>
                    <select
                      className="form-select"
                      name="difficulty"
                      value={formData.difficulty}
                      onChange={handleChange}
                    >
                      <option value="Easy">Easy</option>
                      <option value="Medium">Medium</option>
                      <option value="Hard">Hard</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Marks</label>
                    <input
                      type="number"
                      className="form-control"
                      name="marks"
                      min={1}
                      value={formData.marks}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <button type="submit" className="btn btn-success">
                    Update Question
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditQuestions;
